import countriesData from 'country-region-data'

const plugin = {
  install(Vue) {
    Vue.filter('address', function ({ address, country, state, zipCode }) {
      const countryData = countriesData.find(
        ({ countryShortCode }) => countryShortCode === country
      )

      const countryName = countryData
        ? countryData.countryName
        : 'Unknown Country'

      const stateData =
        countryData &&
        countryData.regions.find(({ shortCode }) => shortCode === state)

      const stateName = stateData ? stateData.name : 'Unknown State/Province'

      return `${address}\n${stateName}, ${zipCode}\n${countryName}`
    })
  }
}

export default plugin
